import { Mail, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import type { EmailSendTranslations } from './types';

interface EmailSendActionsProps {
  isSending: boolean;
  canSend: boolean;
  t: EmailSendTranslations;
  onCancel: () => void;
  onSend: () => void;
}

export function EmailSendActions({
  isSending,
  canSend,
  t,
  onCancel,
  onSend
}: EmailSendActionsProps) {
  return (
    <div className="flex gap-3 p-5 border-t border-border">
      <Button
        onClick={onCancel}
        variant="outline"
        disabled={isSending}
        className="flex-1 h-[50px] rounded-[5px]"
      >
        {t.cancel}
      </Button>
      <Button
        onClick={onSend}
        disabled={!canSend}
        className="flex-1 h-[50px] rounded-[5px] bg-primary hover:bg-primary-hover text-white disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSending ? (
          <>
            <Loader2 className="w-5 h-5 mr-2 animate-spin" />
            {t.sending}
          </>
        ) : (
          <>
            <Mail className="w-5 h-5 mr-2" />
            {t.send}
          </>
        )}
      </Button>
    </div>
  );
}
